import markdownToHtmlConverter from '@/utils/markdown-to-html-converter.js'
import config from '@/common/config'
import { success, fail } from './result-helper'

const extractHeaderData = (headers) => {
  return headers.split('|').reduce((acc, header) => {
    const keyAndValue = header.split(':')
    return {
      ...acc,
      ...{
        [keyAndValue[0]]: keyAndValue[1],
      },
    }
  }, {})
}

export const getServiceStatus = async () => {
  try {
    return await fetch(config.get('app.status.url'))
      .then((response) => {
        if (!response.ok) return fail()
        return response.text()
      })
      .then((markdownText) => {
        // Extract header
        const fileLines = markdownText.replace(/\r\n/g, '\n').split('\n')
        const statusHeader = fileLines[0]
        fileLines.shift()

        const headerElements = extractHeaderData(statusHeader)

        return Promise.resolve(
          success({
            ...{
              _md: markdownText,
              html: markdownToHtmlConverter(fileLines.join('\n')),
            },
            ...headerElements,
          })
        )
      })
  } catch (e) {
    return fail({ error: e, message: e.message })
  }
}
